;(async () => {
  const initialize = (await import("../website_script/initialize")).initialize

  // Listen for the config ready event
  window.addEventListener("auConfigReady", () => {
    initialize(window)
  })

  initialize(window)
})()
